import React from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ROUTE_QUESTION } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const styles = {
  root: {
    backgroundColor: "#FE845A",
    // minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    color: "#ffffff",
    fontFamily: "'Poppins', sans-serif",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  logo: {
    width: "109px",
    height: "58px",
    marginBottom: "20px",
    top: "10px",
    position: "absolute",
  },
  image: {
    borderRadius: "50%",
    width: "101px",
    height: "101px",
    marginBottom: "20px",
    marginTop: "30px",
  },
  section: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "5px",
  },
  subText: {
    fontSize: "14px",
    fontWeight: "600",
    textAlign: "center",
  },
  button: {
    padding: "15px 50px",
    color: "#756DE9",
    backgroundColor: "#ffffff",
    borderRadius: "99px",
    fontSize: "16px",
    fontWeight: "600",
    textTransform: "capitalize",
    width: "100%",
    marginTop: "20px",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  profileConsist: {
    marginBottom: "20px", // Add margin to create gap between line and first point
  },
};

const TakeTest = () => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.root}>
      <img
        src="images/Seevi-Logo-White.png"
        alt=""
        style={{ width: "109px", height: "58px", marginBottom: "20px", top: "2px", position: "absolute" }}
      />

      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/9a279926f5968dd284eadea876740cae4d9b2d5f151b00029f0d8a7926ba9262?apiKey=d94ace7eb9234970be6d52e95c888888&"
        alt=""
        style={styles.image}
      />

      <Typography variant="h6" textAlign="center" sx={styles.section}>
        Go ahead. Discover your unique WorkWise personality.
      </Typography>

      <Stack direction="column" alignItems="center" sx={{ marginBottom: "20px", mt: 2 }}>
        {[1, 2, 3, 4].map((item, index) => (
          <React.Fragment key={item}>
            <Stack direction="column" alignItems="center" sx={{ mt: index !== 0 ? 1 : 0 }}>
              <Typography sx={styles.subText}>
                {item === 1
                  ? "It is mandatory to answer all questions."
                  : item === 2
                  ? "Read each statement carefully and select the option you most identify with."
                  : item === 3
                  ? "Complete the test in one sitting (approximately 15 min)."
                  : "Keep in mind you can take the test only once."}
              </Typography>
            </Stack>
            {index !== 3 && <Divider sx={{ backgroundColor: "#ffffff", mt: 2, mb: 2, width: "100%" }} />}
          </React.Fragment>
        ))}
      </Stack>

      <Button onClick={() => navigate(ROUTE_QUESTION)} sx={styles.button} variant="contained" size="small">
        Take The Test Now
      </Button>
    </Box>
  );
};

export default TakeTest;
